import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Box, Text, Container } from '@radix-ui/themes';

import Card from '../../../../shared/Card';
import { VaultTable } from '../VaultTable.jsx';
import { useGetVaultFiles } from '../../data';
import useSort from '../../../../shared/Sort/useSort';

export const CategoryDetailView = ({
  category,
  categories,
  vendors,
  uploadingFiles,
}) => {
  const { t } = useTranslation('vault');
  const [showAll, setShowAll] = useState(false);
  const [page, setPage] = useState(1);
  const { sortingStatus, changeSort } = useSort({
    persistInUrl: true,
    storageKey: `category_${category.value}`,
  });

  const itemsPerPage = 10;
  const onPageChange = data => setPage(data.selected + 1);

  const { isLoading, data = { vaultFiles: [], pagy: {} } } = useGetVaultFiles({
    page,
    itemsPerPage,
    showAll,
    category: category.value,
    ...sortingStatus,
  });

  const { pagy, vaultFiles } = data;

  const categoryUploadingFiles = uploadingFiles.filter(
    file => file.vaultCategoryId === category.value,
  );

  const showPagination = vaultFiles.length || categoryUploadingFiles.length;

  return (
    <Flex direction="column" gap="4">
      {!isLoading && (
        <Card
          title={t('categoryFiles', { categoryName: category.label })}
          items={showPagination && !showAll ? itemsPerPage : undefined}
          pagy={showPagination && !showAll ? pagy : undefined}
          onPageChange={showPagination && !showAll ? onPageChange : undefined}
          onClick={() => setShowAll(!showAll)}
          canShowAll={showPagination}
          isShowingAll={showAll}
          margin="0"
        >
          <Box p="0 16px">
            {vaultFiles.length || categoryUploadingFiles.length ? (
              <VaultTable
                vaultFiles={vaultFiles}
                uploadingFiles={categoryUploadingFiles}
                categories={categories}
                vendors={vendors}
                sortingStatus={sortingStatus}
                changeSort={changeSort}
              />
            ) : (
              <Container size="2" p="6" mx="auto" style={{ maxWidth: '500px' }}>
                <Flex direction="column" align="center" gap="4">
                  <Text
                    size="3"
                    align="center"
                    color="gray"
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    {t('noCategoryFiles', { categoryName: category.label })}
                  </Text>
                </Flex>
              </Container>
            )}
          </Box>
        </Card>
      )}
    </Flex>
  );
};
